<template>
    <div id="login-record">
        <div id="login-record-line">
            <div>
                <p>登陆时间</p>
                <p>(最近3个月的登陆时间)</p>
            </div>

            <hr/>

            <div class="login-record-item" v-for="(item, index) in loginRecord" :key="index">
                {{item.createdAt}}
            </div>
        </div>
    </div>
</template>

<script>
    import {LoginLog} from "../api/Login";
    import {formatDate} from "../unitls"

    export default {
        name: "LoginRecord",

        data() {
            return {
                loginRecord: []
            }
        },

        mounted() {
            this.getStampExchangeLogList()
        },

        methods: {
            getStampExchangeLogList(){
                LoginLog(0,-1).then(response => {

                    if (this.$API_CODE.OK === response.code) {
                        this.loginRecord = [];

                        response.data.list.forEach((item) => {
                            this.loginRecord.push({
                                createdAt: formatDate(item.createdAt, 'yyyy-MM-dd hh:mm:ss')
                            })
                        })
                    }

                })
            }
        }
    }
</script>

<style scoped lang="scss">
    #login-record {
        background-color: #FFFFFF;


        #login-record-line {
            border: 1px solid #ed3f14;
            margin-top: 10px;
            border-radius: 10px;
            padding: 10px 20px 10px 20px;

            .login-record-item {
                height: 40px;
                border-bottom: 1px dashed #dddddd;
                line-height: 40px;
            }
        }
    }
</style>